/**
 * Splits a list of emails delimitted by a semi-color
 * @param {string} emails - A list of emails seperated by semi-color
 * @return {string[]} - A list of emails
 */
const splitEmailString = (emails) => emails.replace(/\s/g, '').split(';');

/**
 * Convertes Text to Html
 * @param {string} textarea - text to convert to HTML
 * @return {string}
 */
export const getHtmlFromTxt = (textarea) => {
  const mask = '\n';
  const re = new RegExp(mask, 'g');
  return textarea.replace(re, '<br>');
};

/**
 * Removes the first line from a textarea string.
 * @param {string} textarea
 * @return {string}
 */
export const removeFirstLine = (textarea) => (
  textarea.substring(textarea.indexOf('\n') + 1)
);

export default splitEmailString;
